import styled from "styled-components";

export const PageContainer = styled.div`
  min-height: calc(100vh - 450px);
  padding: 50px 20px;
  margin: 0 auto;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin-bottom: 50px;
  img {
    object-fit: contain;
    &.monoti {
      width: 80px;
      height: 80px;
      border-radius: 10px;
      box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    }
    &.shop {
      width: 200px;
      height: 100px;
    }
  }
  h3 {
    font-size: 30px;
    font-weight: 900;
  }
  span {
    font-size: 22px;
    font-weight: 700;
    text-align: center;
    padding: 0 20px;
  }
`;

export const Point = styled.em`
  font-style: normal;
  font-size: 18px;
  display: inline-block;
  color: #0074ca;
`;

export const JoinFormContainer = styled.div`
  max-width: 600px;
  display: block;
  margin: 0 auto;
  .check {
    font-size: 14px;
    display: flex;
    gap: 10px;
    align-items: center;
    input[type="checkbox"] {
      appearance: none;
      width: 22px;
      height: 22px;
      border: 1px solid #ccc;
      padding: 0;
      &:checked {
        border: 0.3em solid #fff;
        outline: 1px solid #ccc;
        background-color: #0074ca;
        box-shadow: none !important;
      }
    }
  }
  .sectionInfo {
    padding-bottom: 10px;
    margin-bottom: 50px;
    border-bottom: 1px solid #333;
    span {
      display: block;
      &:first-child {
        color: #0074ca;
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 10px;
      }
      &:last-child {
        font-size: 12px;
        color: #5e5e5e;
      }
    }
  }
  .fields {
    margin: 50px 0;
    font-size: 16px;
    li {
      label {
        font-size: 16px;
      }
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .tit {
        font-weight: 700;
        margin-bottom: 10px;
        .point {
          font-size: 0;
          font-style: normal;
          &::after {
            width: 12px;
            height: 12px;
            display: inline;
            content: "*";
            font-size: 18px;
            font-weight: 500;
            color: #0074ca;
            margin-left: 8px;
          }
        }
      }
      .cont {
        display: flex;
        align-items: center;
        input[type="text"],
        input[type="password"] {
          width: 100%;
          padding: 0 20px;
          height: 50px;
          border: 1px solid #ccc;
          color: #333;
        }
        &.duplicate {
          input[type="text"],
          input[type="password"] {
            width: calc(100% - 100px);
          }
          button {
            width: 100px;
            height: 50px;
            background: #333;
            color: #fff;
            border: none;
          }
        }
      }
    }
  }
  .all {
    margin-bottom: 20px;
  }
  .agreements {
    border: 1px solid #0074ca;
    padding: 20px;
    li {
      margin-bottom: 20px;
      font-size: 14px;
      &:last-child {
        margin-bottom: 0;
      }
      button {
        font-size: 12px;
        border: 1px solid #333;
        background: #fff;
        padding: 2px 5px;
        border-radius: 5px;
      }
    }
  }
  .submit {
    margin: 50px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 50px;
    background: #0074ca;
    border: none;
    color: #fff;
    font-size: 18px;
    svg {
      display: block;
      margin: 0;
    }
  }
`;
